/* eslint-disable camelcase */
import { extend } from 'vee-validate'
import { required, email, alpha_spaces, integer, regex, min, max, max_value } from 'vee-validate/dist/rules'
import pt from 'vee-validate/dist/locale/pt_BR.json'

// Install required rule and message.
extend('required', {
  ...required,
  message: pt.messages.required
})

extend('alpha_spaces', {
  ...alpha_spaces,
  message: pt.messages.alpha_spaces
})

extend('integer', {
  ...integer,
  message: pt.messages.integer
})

extend('regex', {
  ...regex,
  message: pt.messages.regex
})

extend('min', {
  ...min,
  message: pt.messages.min
})

extend('max', {
  ...max,
  message: pt.messages.max
})

extend('max_value', {
  ...max_value,
  message: pt.messages.max_value
})

extend('email', {
  ...email,
  message: pt.messages.email
})

extend('password', {
  validate: (value, { other }) => value === other,
  message: 'As senhas informadas são diferentes.',
  params: [{ name: 'other', isTarget: true }]
})
